<template lang="pug">
    .wrapper.spacingBottomSmall(ref="container")
        .is-loading(v-if="isLoading")
            Spinner(
                :size="16"
                :thickness="3"
            )
            h4.text-center.text-lg Veranstaltung wird geladen
        .appointment.container.mx-auto.p-4.clear(v-else-if="appointment")
            .appointment-images(v-if="appointmentImages && appointmentImages.length > 0")
                .appointmentImage.p-4(
                    v-for="(appointmentImage, index) in appointmentImages"
                    v-if="index <= 1 && height"
                    :alt="appointmentImage.title"
                    :class="imageClass"
                )
                    .image-wrapper(:style="imageStyle(appointmentImage.url)")
            p.w-full.px-4(v-if="appointmentImages && appointmentImages.length && appointmentImages[0].sub_title" v-html="appointmentImages[0].sub_title")
            .appointment-text
                h2 {{ appointmentTitle }}
                .description(v-html="appointmentDescription")
            .info-box
                h3.font-bold.mb-4 Informationen
                .information-list
                    .details
                        .information.no(
                            v-for="detail in appointmentDetails"
                            v-if="detail.typ !== 'hidden'"
                        )
                            span.font-bold.left {{ detail.key }}
                            a.text-left.right(v-if="detail.typ === 'link'", :href="getURL(detail.value)", class="w-3/4", target="_blank") Anzeigen
                            .detail.text-left(
                                v-if="detail.typ !== 'link'"
                                class="w-3/4"
                                v-html="detail.value"
                            )
                    .buttons.w-m-48.p-r-4
                        a.btn.pdf(v-if="pdfURL", :href="pdfURL", target="_blank") PDF drucken
                        router-link.btn.signup(
                            v-if="appointmentNo && currentDate <= parseDate(registrationEnds) || !registrationEnds"
                            :to="{ name:'seminar_signup', params: {nr: appointmentNo} }"
                        ) Jetzt anmelden
                        button.btn.signup.disabled(v-else) Jetzt anmelden
                        span.registration-info(v-if="registrationEnds && currentDate > parseDate(registrationEnds)")
                            small Anmeldeschluss war bereits am {{ registrationEnds }}!
                        //- button.signup Jetzt anmelden
</template>
<script>
//import Components
import { get, debounce } from '@/helpers';
import axios from 'axios';
import getUnixTime from 'date-fns/getUnixTime';

export default {
    name: 'AppointmentDetailPage',
    components: {
        // Component
    },
    data() {
        return {
            appointmentNo: false,
            appointment: {},
            isLoading: true,
            maxW: undefined,
            currentDate: getUnixTime(new Date()),
            registrationEnded: false
        };
    },
    computed: {
        appointmentImages() {
            return get(this.appointment, 'images', []);
        },
        // appointmentNo() {
        //     let result = false;
        //     // console.log(this.appointment);
        //     // if (this.appointment && this.appointmentDetails) {
        //     result = this.appointment.informations.find(detail => {
        //         detail.key === 'Seminarnummer';
        //     });
        //     // }
        //     return result;
        //     // return get(this.appointmentDetails, 'informations')
        // },
        appointmentTitle() {
            return get(this.appointment, 'title', false);
        },
        appointmentDetails() {
            return get(this.appointment, 'informations', []);
        },
        appointmentDescription() {
            return get(this.appointment, 'description', '');
        },
        imageClass() {
            let styleClass = 'w-full';
            if (this.appointmentImages && this.appointmentImages.length > 1) styleClass = 'w-1/2';
            if (this.maxW < 1024) styleClass = 'w-full';
            return styleClass;
        },
        pdfURL() {
            let url = false;
            if (this.appointment && this.appointment.uid) {
                url = `${process.env.VUE_APP_HOMEPAGE_PDF_BASE_URL}?${process.env.VUE_APP_HOMEPAGE_PDF_URL_FUNC}=${this.appointment.uid}&${this.currentDate}&${process.env.VUE_APP_HOMEPAGE_PDF_URL_TYPE}`;
            }
            return url;
        },
        height() {
            // return (this.maxW / this.appointmentImages.length) * 0.75
            return 350;
        },
        registrationEnds() {
            let value = false;
            if (this.appointment && this.appointment.informations)
                value =
                    this.appointment.informations.find(information => {
                        return information.key === 'Anmeldeschluss';
                    }) || false;
            if (value) value = value.value;
            return value;
        }
    },
    methods: {
        parseDate(input) {
            let date = false;
            if (input) {
                var parts = input.match(/(\d+)/g);
                // note parts[1]-1
                date = getUnixTime(new Date(parts[2], parts[1] - 1, parts[0]));
            }
            return date;
        },
        getImageUrl(path) {
            return `https://semkast.de/${path}`;
        },
        getURL(url) {
            let URI = '';
            if (url.startsWith('/')) {
                URI = `https://website.karl-arnold-stiftung.de${url}`;
            } else {
                URI = url;
            }
            return URI;
        },
        imageStyle(url) {
            let style = {};
            if (url) {
                style = {
                    background: `url('${this.getImageUrl(url)}')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    height: this.height + 'px'
                };
            }

            return style;
        }
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container);
                this.maxW = this.$refs.container.clientWidth;
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        };
        const route = this.$route.params;
        this.appointmentNo = get(route, 'nr', false);
        if (this.appointmentNo) {
            // const detailUrl = `${process.env.VUE_APP_CRM_APPOINTMENTS_BASE_URL}${process.env.VUE_APP_CRM_APPOINTMENTS_BASE_PATH}?${process.env.VUE_APP_CRM_APPOINTMENTS_PAGE_ID}&${process.env.VUE_APP_CRM_APPOINTMENTS_EXTENSION}${process.env.VUE_APP_CRM_APPOINTMENTS_DETAILS_ACTION}&${process.env.VUE_APP_CRM_APPOINTMENTS_EXTENSION}${process.env.VUE_APP_CRM_APPOINTMENTS_CONTROLLER}&${process.env.VUE_APP_CRM_APPOINTMENTS_PAGE_TYPE}&eventUid=${this.appointmentNo}`;
            const detailUrl = `${process.env.VUE_APP_CRM_APPOINTMENTS_BASE_URL}${process.env.VUE_APP_CRM_APPOINTMENTS_JSON_EXPORT_DETAILS_PATH}&eventUid=${this.appointmentNo || ''}`;
            axios({
                method: 'post',
                // url: 'http://127.0.0.1:88/index.php?id=43&tx_crm_stammdaten%5Baction%5D=eventDetails&tx_crm_stammdaten%5Bcontroller%5D=Jsonexport&type=1391118105&eventUid=' + appointmentNo
                url: detailUrl
            })
                .then(response => {
                    this.appointment = response.data || [];
                    this.isLoading = false;
                })
                .catch(e => {
                    this.isLoading = false;
                    console.log(e);
                });
            // this.appointment = this.demoAppointments.find(appointment => {
            //     return appointment.no === appointmentNo;
            // });
        }
        calculateMaxWidth();
        // debounce(calculateMaxWidth, 500)
        window.addEventListener('resize', debounce(calculateMaxWidth, 100));
    }
};
</script>
<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.wrapper
    min-height: 100%
    display: flex
    .is-loading
        align-self: center

.is-loading
    width: 100%
    height: 100px
.appointment
    @media print
        padding: 0 !important
    @apply mt-8
.info-box
    margin: 0 1rem
    background-color: #d0cec3
span.left
    @apply font-bold
    flex-basis: 35%
.right
    flex-basis: 60%
a.right
    &:hover
        text-decoration: underline
        cursor: pointer
.pdf
    @apply p-4 mb-4 rounded text-white text-center
    background-color: $kas-olive
    &:hover
        background-color: lighten($kas-olive, 5%)
.signup
    @apply p-4 rounded text-white text-center
    background-color: $kas-navy
    &:hover
        background-color: lighten($kas-navy, 5%)
    &.disabled
        cursor: not-allowed
        background-color: lighten($kas-navy, 35%)
        &:hover
            background-color: lighten($kas-navy, 35%)
.information
    @apply flex flex-col justify-between py-1
.appointment-images
    @apply flex flex-col-reverse justify-around
.information-list
    @apply flex flex-col justify-between
.details
    @apply flex flex-col
.info-box
    @apply py-8 px-4 my-16
.buttons
    @media print
        display: none
    @apply flex flex-col justify-end content-end mt-4
.appointment-text::v-deep
    @apply py-8 px-4 my-4
    @screen lg
        @apply my-8
    .description a
        text-decoration: underline
        &:hover
            color: #63614e
@screen lg
    .appointment
        @apply mt-0
    .appointment-images
        @apply flex-row-reverse
    .details
        @apply w-3/4
    .information-list
        @apply flex-row
    .information
        @apply flex-row
    .buttons
        mt-0
    .info-box
        @apply p-16
.detail::v-deep
    ul
        list-style: unset
        padding-left: 1rem
        li:empty
            display: none
    a
        text-decoration: underline

    a[href^="http"]::after,
    a[href^="https://"]::after,
    a[href^="mailto:"]::after,
    a[href^="tel:"]::after
        content: ''
        width: 11px
        height: 11px
        margin-left: 4px
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z'/%3E%3Cpath fill-rule='evenodd' d='M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z'/%3E%3C/svg%3E")
        background-position: center
        background-repeat: no-repeat
        background-size: contain
        display: inline-block

</style>
